'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonation = exports.fetchDonationFeed = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _jsonDate = require('../../../utils/jsonDate');

var _jsonDate2 = _interopRequireDefault(_jsonDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchDonationFeed = exports.fetchDonationFeed = function fetchDonationFeed(_ref) {
  var campaign = _ref.campaign,
      charity = _ref.charity,
      page = _ref.page,
      donationRef = _ref.donationRef;

  if (charity) {
    return fetchDonationFeedForCharity(charity);
  }

  if (campaign) {
    return fetchDonationFeedForCampaign(campaign);
  }

  if (page) {
    return fetchDonationFeedForPage(page);
  }

  if (donationRef) {
    return fetchDonationFeedByRef(donationRef);
  }

  return Promise.reject('You must pass a charity UID, page shortName, campaign GUID or donationRef for this method');
};

var fetchDonationFeedForPage = function fetchDonationFeedForPage(page) {
  return (0, _client.get)('v1/fundraising/pages/' + (0, _params.getShortName)(page) + '/donations?pageSize=150').then(function (data) {
    return data.donations;
  });
};

var fetchDonationFeedForCharity = function fetchDonationFeedForCharity(charity) {
  return (0, _client.get)('v1/charity/' + (0, _params.getUID)(charity) + '/donations').then(function (data) {
    return data.donations;
  });
};

var fetchDonationFeedForCampaign = function fetchDonationFeedForCampaign(campaign) {
  return (0, _client.get)('donations/v1/donations?take=100&externalref=campaignGuid:' + (0, _params.getUID)(campaign)).then(function (data) {
    return data.results;
  });
};

var fetchDonationFeedByRef = function fetchDonationFeedByRef(ref) {
  return (0, _client.get)('v1/donation/ref/' + ref).then(function (data) {
    return data.donations;
  });
};

var deserializeDonation = exports.deserializeDonation = function deserializeDonation(donation) {
  var isFromDonationsAPI = !!donation.donationId;

  return {
    amount: parseFloat(donation.donorLocalAmount || donation.amount || donation.donationAmount || 0),
    anonymous: isFromDonationsAPI ? !donation.donor : !donation.donorDisplayName || donation.donorDisplayName.toLowerCase().trim() === 'anonymous',
    charity: donation.charityId,
    createdAt: donation.donationDate ? (0, _jsonDate2.default)(donation.donationDate) : (0, _jsonDate2.default)(donation.date),
    currency: donation.donorLocalCurrencyCode || donation.currencyCode,
    donationRef: donation.thirdPartyReference,
    message: donation.message || donation.donorMessage,
    name: isFromDonationsAPI ? donation.donor && donation.donor.name : donation.donorDisplayName,
    page: donation.pageShortName
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/feeds/justgiving/index.js
// module id = 1307
// module chunks = 0